import axios from 'axios';
import { BASEURL } from '../config/api';
import { clearSession, getSession } from './session';

const axiosInstance = axios.create({ baseURL: BASEURL, timeout: 30000 });
axiosInstance.interceptors.request.use((config) => {
  const target = new URL(config.url, `${BASEURL.replace(/\/$/, '')}/`);
  if (target.origin !== new URL(BASEURL, window.location.origin).origin) {
    throw new Error('Requests to an untrusted API origin are blocked.');
  }
  const session = getSession();
  if (session?.token) config.headers.Authorization = `Bearer ${session.token}`;
  if (session?.csrfToken) config.headers['X-CSRF-Token'] = session.csrfToken;
  return config;
});
axiosInstance.interceptors.response.use(
  (response) => {
    if (response.data?.success === false) {
      return Promise.reject(new Error(response.data.message || 'The request was not completed.'));
    }
    if (!['get', 'head', 'options'].includes(response.config.method)) {
      window.dispatchEvent(new Event('dashboard:data-changed'));
    }
    return response.data;
  },
  (error) => {
    if (error.response?.status === 401 && !error.config?.url?.endsWith('/users/login')) {
      clearSession();
      window.location.replace(window.location.pathname.startsWith('/doctor/') ? '/doctor/login' : '/login');
    }
    // Preserve Axios status/response for callers that distinguish 404, 403, and network errors.
    error.message = error.response?.data?.message || error.message;
    return Promise.reject(error);
  }
);
export default axiosInstance;
